import { Component, OnInit, Output, EventEmitter, ViewChild, Inject } from '@angular/core';
import { AuthService } from 'app/shared/services/auth.service';
import { RouteService } from '../../services/route.service';
import { environment } from 'environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { AppMessage } from 'app/_services/app.message/app.message.model';
import { AppMessageType } from 'app/_services/app.message/app.message.type';
import { AppMessageService } from 'app/_services/app.message/app.message.service';

@Component({
  selector: 'reuse-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  recaptchaKey: string;
  tokenCaptcha: string;
  captchaMocked: boolean;
  loginGovernoMocado: boolean = false;
  loginGovernoHabilitado: boolean = false;
  loginGovernoMunicipalEstadualHabilitado: boolean = false;
  loginPrivadoHabilitado: boolean = false;
  loginGovMocadoHabilitado: boolean = false;
  exibirBotoesTiposLogin: boolean = true;
  listaPerfil: Array<{ id: string, nome: string }> = [
    { id: 'PUBLICO_FEDERAL', nome: 'FEDERAL' },
    { id: 'ESTADUAL_MUNICIPAL', nome: 'ESTADUAL/MUNICIPAL' }
  ];
perfilSelecionado: string = 'PUBLICO_FEDERAL';


  @Output() finished = new EventEmitter();

  @ViewChild('captcha') captcha;

  constructor(
    private authService: AuthService,
    private routeService: RouteService,
    private route: ActivatedRoute,
    private router: Router,
    private appMessageService: AppMessageService,
    @Inject(DOCUMENT) private document: any
  ) { }

  ngOnInit() {
    this.criarBreadcrumb();
    this.addScript();
    this.verificaLoginGovBr();
    this.definirTipoLogin();

    this.recaptchaKey = environment.recaptchaKey;
    this.authService.captchaMocked().subscribe(
      resultado => {
        if (resultado) {
          this.captchaMocked = resultado;
        } else {
          this.captchaMocked = false;
        }
      }
    )
    this.loginGovBrMocado();
  }

  /**
  * Configuração da barra 'Breadcrumb'.
  */
  private criarBreadcrumb(): void {
    let breadcrumbItems = [
      { icon: 'fa fa-user', label: 'Login', command: (onclick) => { this.router.navigate(['/login']) } }
    ];
    this.appMessageService.sendMessage(new AppMessage(AppMessageType.BREADCRUMB, breadcrumbItems));
  }

  cancelar() {
    this.finished.emit();
    this.goUrl(true);
  }

  showResponse(response: string) {
    this.tokenCaptcha = response;
  }

  loginGoverno(usuario, senha) {
    const tokenCaptcha = this.tokenCaptcha;
    this.tokenCaptcha = undefined;

    if (this.captcha) {
      this.captcha.reset();
    }

    this.authService.login(usuario, senha, tokenCaptcha).subscribe(
      t => {
        if (t) {
          this.notificarLogin();
          this.goUrl(false);
        }
      }
    );
  }

  doLoginGovernoMocado(usuario, tipo) {
    let tipoLogin = 'PUBLICO_FEDERAL';
    if (tipo && tipo.id) {
      tipoLogin = tipo.id;
    }
    this.authService.loginGovMocado(usuario, tipoLogin).subscribe(
      t => {
        if (t) {
          this.notificarLogin();
          this.goUrl(false);
        }
      }
    );
  }

  buscarUrlLoginGovBr() {
    this.authService.buscarUrlLoginGovBr().subscribe(
      (resultado) => {
        this.document.location.href = resultado.mensagem;
      }
    );
  }

  buscarUrlLoginGovBrPublico() {
    this.authService.buscarUrlLoginGovBrPublico().subscribe(
      (resultado) => {
        this.document.location.href = resultado.mensagem;
      }
    );
  }

    buscarUrlLoginGovBrPublicoEstadosEMunicipios() {
    this.authService.loginGovBrPublicoEstadosEMunicipios().subscribe(
      (resultado) => {
        this.document.location.href = resultado.mensagem;
      }
    );
  }

  verificaLoginGovBr() {
    const parametrosUrl = this.route.snapshot.queryParams;
    if (parametrosUrl['token']) {
      this.authService.loginGovBr(parametrosUrl['token']);
      this.notificarLogin();
      this.goUrl(false);
    } else if (parametrosUrl['mensagemErroLoginGovBr']) {
      this.authService.erroLoginGovBr(parametrosUrl['mensagemErroLoginGovBr']);
    }
  }

  loginGovBrMocado() {

    // Mock do login Gov.br para fins de desenvolvimento
    // Se estiver rodando localmente ou em ambiente de desenvolvimento, permite o mock
    let allowedDomain = [
      'http://localhost:4200',
      'https://d-reuse.estaleiro.serpro.gov.br',
      'https://t-reuse.estaleiro.serpro.gov.br',
      'https://d-reuse.np.bsa.estaleiro.serpro.gov.br',// novo ambiente de testes
      'https://t-reuse.np.bsa.estaleiro.serpro.gov.br'//
    ];
    if(allowedDomain.includes(window.location.origin)) {
      console.warn('Mock do login Gov.br ativado para desenvolvimento');
      this.authService.loginUsuarioMocked().subscribe(
        resultado => {
          if (resultado) {
            this.loginGovernoMocado = resultado;
          } else {
            this.loginGovernoMocado = false;
          }
        }
      );
    }
  }

  private goUrl(iCancelButton: boolean) {
    this.finished.emit();

    let url: string;

    if (iCancelButton) {
      // se o usuario clicou em cancelar, entao volta para a url anterior
      url = this.authService.redirectUrlCancel;
    } else {
      url = this.authService.redirectUrlSuccess;
    }

    //Se for undefined, vai para a tela padrao
    if (!url) {
      url = '';
    }

    if (url.indexOf('/login') !== -1) {
      // se a url de retorno for o proprio login, entao retorna para a padrao
      url = '';
    }

    this.routeService.goUrl(url);

    this.authService.redirectUrlSuccess = undefined;
    this.authService.redirectUrlCancel = undefined;
  }

  initRecaptcha() { }

  addScript() {
    let script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=explicit&onload=initRecaptcha`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  exibirLoginGoverno(habilitado: boolean) {
    this.loginGovernoHabilitado = habilitado;
    this.loginPrivadoHabilitado = !habilitado;
    this.loginGovernoMunicipalEstadualHabilitado = !habilitado;
    this.loginGovMocadoHabilitado = false;
  }

  exibirLoginPrivado(habilitado: boolean) {
    this.loginGovMocadoHabilitado = false;
    this.loginPrivadoHabilitado = habilitado;
    this.loginGovernoHabilitado = !habilitado;
    this.loginGovernoMunicipalEstadualHabilitado = !habilitado;
  }

  exibirLoginGovMocado(habilitado: boolean) {
    this.loginGovMocadoHabilitado = habilitado;
    this.loginGovernoHabilitado = !habilitado;
    this.loginPrivadoHabilitado = !habilitado;
    this.loginGovernoMunicipalEstadualHabilitado = !habilitado;
  }

  exibirLoginGovernoMunicipalEstadual(habilitado: boolean) {
    this.loginGovernoMunicipalEstadualHabilitado = habilitado;
    this.loginGovernoHabilitado = !habilitado;
    this.loginPrivadoHabilitado = !habilitado;
    this.loginGovMocadoHabilitado = false;
  }

  definirTipoLogin() {
    if (this.authService.redirectUrlSuccess && this.authService.redirectUrlSuccess.endsWith('/tenho-interesse')) {
      this.exibirBotoesTiposLogin = false;
    } else {
      this.exibirBotoesTiposLogin = true;
    }
  }

  private notificarLogin() {
    this.appMessageService.sendMessage(new AppMessage(AppMessageType.LOGIN));
  }
}
